import { connect } from 'react-redux';
import ProxyLoginUser from "../components/ProxyLoginUser/ProxyLoginUser";

import * as actions from '../redux/actions/ProxyLoginUser';

const mapStateToProps = (state) => {
  return {
    user: state.proxyLoginUser.user,
    isProxyLoginLoading: state.proxyLoginUser.isProxyLoginLoading,
    proxyLoggedIn: state.proxyLoginUser.proxyLoggedIn,
  };
};

const mapDispatchToProps = dispatch => ({
  getProxyLoginUser(id, token) {
    dispatch(actions.getProxyLoginUser(id, token));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProxyLoginUser);



// WEBPACK FOOTER //
// ./src/containers/ProxyLoginUser.js